import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LocationProvider } from "./context/LocationContext";
import { CartProvider } from "./context/CartContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
// import Products from "./pages/Products";
// import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import ReturnPolicy from "./pages/ReturnPolicy";
// import Blog from "./pages/Blog";
// import Cart from "./pages/Cart";
// import Checkout from "./pages/Checkout";
// import OrderConfirmation from "./pages/OrderConfirmation";
// import Auth from "./pages/Auth";
// import Dashboard from "./pages/Dashboard";
// import OrderTracking from "./pages/OrderTracking";
// import Wishlist from "./pages/Wishlist";
import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/ScrollToTop";
import SingleBlog from "./pages/SingleBlog";
import Blogs from "./pages/Blogs";
import Landingpage from "./pages/Landingpage";
import NotFound from "./pages/NotFound";

function App() {
return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <LocationProvider>
            <CartProvider>
              <div className="App min-h-screen flex flex-col">
                <Header />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    {/* <Route path="/products" element={<Products />} />
                    <Route path="/product/:id" element={<ProductDetail />} /> */}
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/shipping-policy" element={<ShippingPolicy />} />
                    <Route path="/return-policy" element={<ReturnPolicy />} />
                    {/* <Route path="/blog" element={<Blog />} /> */}
                    {/* <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/order-confirmation/:orderId?" element={<OrderConfirmation />} /> */}

                    {/* New Routes */}
                    {/* <Route path="/auth" element={<Auth />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/order-tracking/:orderId" element={<OrderTracking />} />
                    <Route path="/wishlist" element={<Wishlist />} /> */}
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blogs/:slug" element={<SingleBlog />} />
                    <Route path="/ramzan-special-food" element={<Landingpage />} />
                    {/* Redirect typo /landinpage to /landingpage */}
                    {/* <Route path="/" element={<Navigate to="/ramzan-special-food" replace />} /> */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
                <Toaster />
              </div>
            </CartProvider>
          </LocationProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
